function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { DatePicker } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import Form from "./Form";
import Search from "./Search";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DATE_FMT = 'YYYY-MM-DD';
export var DATE_PROPS = {
  getValueFromEvent: function getValueFromEvent(e) {
    return e === null || e === void 0 ? void 0 : e.startOf('day').format(DATE_FMT);
  },
  getValueProps: function getValueProps(e) {
    return {
      value: e ? dayjs(e) : undefined
    };
  }
};
export var DATE_RANGE_PROPS = {
  getValueFromEvent: function getValueFromEvent(e) {
    var _e$, _e$2;
    if (e == null) return undefined;
    return [(_e$ = e[0]) === null || _e$ === void 0 ? void 0 : _e$.startOf('day').format(DATE_FMT), (_e$2 = e[1]) === null || _e$2 === void 0 ? void 0 : _e$2.startOf('day').format(DATE_FMT)];
  },
  getValueProps: function getValueProps(e) {
    return {
      value: e ? [e[0] ? dayjs(e[0]) : undefined, e[1] ? dayjs(e[1]) : undefined] : undefined
    };
  }
};
export var DateField = function DateField(props) {
  return /*#__PURE__*/_jsx(Form.Field, _objectSpread(_objectSpread(_objectSpread({}, DATE_PROPS), props.fieldProps), {}, {
    children: /*#__PURE__*/_jsx(DatePicker, _objectSpread({
      format: DATE_FMT
    }, props.dateProps))
  }));
};
export var DateSearchField = function DateSearchField(props) {
  return /*#__PURE__*/_jsx(Search.Field, _objectSpread(_objectSpread(_objectSpread({}, DATE_PROPS), props.fieldProps), {}, {
    children: /*#__PURE__*/_jsx(DatePicker, _objectSpread({
      format: DATE_FMT
    }, props.dateProps))
  }));
};
export var DateRangeField = function DateRangeField(props) {
  var _props$dateRangeProps2;
  var fieldKeys = props.fieldKeys;
  var form = useFormInstance();
  var _ref = fieldKeys || [],
    _ref2 = _slicedToArray(_ref, 2),
    startKey = _ref2[0],
    endKey = _ref2[1];
  var onChange = useMemo(function () {
    var _props$dateRangeProps;
    return startKey && endKey ? function (dates) {
      var _ref3 = dates || [],
        _ref4 = _slicedToArray(_ref3, 2),
        start = _ref4[0],
        end = _ref4[1];
      form.setFieldsValue(_defineProperty(_defineProperty({}, startKey, start === null || start === void 0 ? void 0 : start.format(DATE_FMT)), endKey, end === null || end === void 0 ? void 0 : end.format(DATE_FMT)));
    } : (_props$dateRangeProps = props.dateRangeProps) === null || _props$dateRangeProps === void 0 ? void 0 : _props$dateRangeProps.onChange;
  }, [startKey, endKey, form, (_props$dateRangeProps2 = props.dateRangeProps) === null || _props$dateRangeProps2 === void 0 ? void 0 : _props$dateRangeProps2.onChange]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [startKey ? /*#__PURE__*/_jsx(Form.Field, {
      name: startKey,
      hidden: true
    }) : null, endKey ? /*#__PURE__*/_jsx(Form.Field, {
      name: endKey,
      hidden: true
    }) : null, /*#__PURE__*/_jsx(Form.Field, _objectSpread(_objectSpread(_objectSpread({}, DATE_RANGE_PROPS), props.fieldProps), {}, {
      children: /*#__PURE__*/_jsx(DatePicker.RangePicker, _objectSpread(_objectSpread({
        format: DATE_FMT
      }, props.dateRangeProps), {}, {
        onChange: onChange
      }))
    }))]
  });
};
export var DateRangeSearchField = function DateRangeSearchField(props) {
  var _props$dateRangeProps4;
  var fieldKeys = props.fieldKeys;
  var form = useFormInstance();
  var _ref5 = fieldKeys || [],
    _ref6 = _slicedToArray(_ref5, 2),
    startKey = _ref6[0],
    endKey = _ref6[1];
  var onChange = useMemo(function () {
    var _props$dateRangeProps3;
    return startKey && endKey ? function (dates) {
      var _ref7 = dates || [],
        _ref8 = _slicedToArray(_ref7, 2),
        start = _ref8[0],
        end = _ref8[1];
      console.log(start, end);
      form.setFieldsValue(_defineProperty(_defineProperty({}, startKey, start === null || start === void 0 ? void 0 : start.format(DATE_FMT)), endKey, end === null || end === void 0 ? void 0 : end.format(DATE_FMT)));
    } : (_props$dateRangeProps3 = props.dateRangeProps) === null || _props$dateRangeProps3 === void 0 ? void 0 : _props$dateRangeProps3.onChange;
  }, [startKey, endKey, form, (_props$dateRangeProps4 = props.dateRangeProps) === null || _props$dateRangeProps4 === void 0 ? void 0 : _props$dateRangeProps4.onChange]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [startKey ? /*#__PURE__*/_jsx(Search.Field, {
      name: startKey,
      hidden: true
    }) : null, endKey ? /*#__PURE__*/_jsx(Search.Field, {
      name: endKey,
      hidden: true
    }) : null, /*#__PURE__*/_jsx(Search.Field, _objectSpread(_objectSpread(_objectSpread({}, DATE_RANGE_PROPS), props.fieldProps), {}, {
      children: /*#__PURE__*/_jsx(DatePicker.RangePicker, _objectSpread(_objectSpread({
        format: DATE_FMT
      }, props.dateRangeProps), {}, {
        onChange: onChange
      }))
    }))]
  });
};
export var requiredRules = [{
  required: true
}];
export var requiredRulesBuild = function requiredRulesBuild(message) {
  return [{
    required: true,
    message: message
  }];
};